module.exports = __webpack_public_path__ + "img/historico-icon.32b6aad0.svg";